import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'cartao-resumo-curso',
  templateUrl: './cartao-resumo-curso.component.html',
  styleUrls: ['./cartao-resumo-curso.component.scss'],
})
export class CartaoResumoCursoComponent implements OnInit {

  @Input() nome: string;
  @Input() tipo: string;
  @Input() duracao: string;
  @Input() tipoDuracao: string;
  @Input() numParcelas: number;
  @Input() valorParcela: string [];
  @Input() parcelamento: any[];
  @Input() locais: string[];
  @Input() cargaHoraria: number;
  @Input() modificadorDuracao: string;
  @Input() mostrarTooltip = true;

  _tipoDuracao = 'meses';
  _locaisFormatados: string;

  tiposDuracao = [
    {chave: 'a', descricao: 'Anos'},
    {chave: 'm', descricao: 'Meses'},
    {chave: 'd', descricao: 'Dias'},
    {chave: 'h', descricao: 'Horas'},
  ];

  ngOnInit() {
    if (this.tipoDuracao) {
      const tipos = this.tiposDuracao.filter(t => t.chave === this.tipoDuracao.toLowerCase() || t.descricao.toLowerCase() === this.tipoDuracao);
      this._tipoDuracao = tipos.length > 0 ? tipos[0].descricao : '';
    }

    this._locaisFormatados = this.locais && this.locais.length > 0 ? this.locais.reduce((p, c) => p + ', ' + c) : '';
  }

}
